import { useNavigate } from "react-router-dom";
import { canRoute, candidate, empRoute, employer, publicUser } from "../../../globals/route-names";
import { useState } from "react";
import { GoogleLogin } from '@react-oauth/google';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { jwtDecode } from "jwt-decode";
import { addDoc, collection, query, where, onSnapshot, getDocs, updateDoc } from "firebase/firestore";
import { db } from '../../../globals/firebase';
import { useTranslation } from "react-i18next";
import bcrypt from 'bcryptjs';

function SignInPopup() {

    const navigate = useNavigate();
    const { t } = useTranslation();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [name, setName] = useState('');
    const [isSignUp, setIsSignUp] = useState(false);
    const [error, setError] = useState('');
    const [message, setMessage] = useState('');

    const handleEmailAuth = async (e) => {
        e.preventDefault();
        setError('');
        setMessage('');

        try {
            const myCollection = collection(db, 'wpm_users');

            if (isSignUp) {
                // Registration
                if (!name || !email || !password) {
                    setError('All fields are required');
                    return;
                }

                // Check if user exists
                const q = query(myCollection, where("email", "==", email));
                const querySnapshot = await getDocs(q);

                if (!querySnapshot.empty) {
                    setError('User already exists');
                    return;
                }

                // Hash password
                const salt = bcrypt.genSaltSync(10);
                const hashedPassword = bcrypt.hashSync(password, salt);

                const newUser = {
                    userid: "",
                    name: name,
                    email: email,
                    password: hashedPassword, // Store hashed password
                    picture: "",
                    datainsert: Date.now(),
                    creditsprompts: 10,
                    creditsimages: 12
                };

                await addDoc(myCollection, newUser).then(async (doc) => {
                    await updateDoc(doc, { userid: doc.id });
                    newUser.userid = doc.id;
                    localStorage.setItem("user", JSON.stringify(newUser));
                    window.location.href = "/";
                });

            } else {
                // Login
                const q = query(myCollection, where("email", "==", email));
                const querySnapshot = await getDocs(q);

                if (querySnapshot.empty) {
                    setError('Invalid email or password');
                    return;
                }

                const userDoc = querySnapshot.docs[0];
                const userData = userDoc.data();

                // Verify password
                if (!userData.password) {
                     // Handle legacy users or Google users who might not have a password
                     // If they logged in via Google before, they won't have a password.
                     // We can either block them or ask to reset (but we don't have reset flow yet).
                     // For now, fail.
                     setError('Invalid email or password (or use Google Login)');
                     return;
                }

                const passwordIsValid = bcrypt.compareSync(password, userData.password);

                if (!passwordIsValid) {
                    setError('Invalid email or password');
                    return;
                }

                if (!userData.userid) {
                    userData.userid = userDoc.id;
                }

                localStorage.setItem("user", JSON.stringify(userData));
                window.location.href = "/";
            }
        } catch (err) {
            console.error(err);
            setError(err.message);
        }
    };

    return (
        <>
            <div className="modal fade twm-sign-up" id="sign_up_popup2" aria-hidden="true" aria-labelledby="sign_up_popupLabel2" tabIndex={-1}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h2 className="modal-title" id="sign_up_popupLabel2">{isSignUp ? t('auth.signup') : t('auth.login')}</h2>
                            <p>{t('auth.accessfeatures')}</p>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        <div className="modal-body">
                            <div className="col-lg-12">
                                <div style={{ marginBottom: '20px', display: 'flex', justifyContent: 'center' }}>
                                    <GoogleOAuthProvider clientId="306947882627-g9vj62ui865r1tp5d8dv670096bnnncn.apps.googleusercontent.com">
                                        <GoogleLogin
                                            onSuccess={async credentialResponse => {
                                                const cred = jwtDecode(credentialResponse.credential);
                                                let user = {
                                                    userid: "",
                                                    name:cred.name,
                                                    email: cred.email,
                                                    picture: cred.picture,
                                                    datainsert: Date.now(),
                                                    creditsprompts: 10,
                                                    creditsimages:12
                                                }

                                                const myCollection = collection(db, 'wpm_users');
                                                const q = query(myCollection, where("email", "==", user.email));
                                                const userexists = await getDocs(q);

                                                let totaluser = userexists.docs.length

                                                if (totaluser < 1) {
                                                    await addDoc(myCollection, user).then(async (doc) => {
                                                        await updateDoc(doc, {
                                                            userid: doc.id
                                                        });
                                                        user.userid = doc.id
                                                        localStorage.setItem("user", JSON.stringify(user))
                                                    })
                                                }
                                                else {
                                                    user.userid = userexists.docs[0].id
                                                    localStorage.setItem("user", JSON.stringify(user))
                                                }

                                                window.location.href = "/"
                                            }}
                                            onError={() => {
                                                console.log('Login Failed');
                                            }}
                                        />
                                    </GoogleOAuthProvider>
                                </div>
                                
                                <div className="text-center" style={{ margin: '20px 0' }}>
                                    <span>{t('sidebar.or')}</span>
                                </div>

                                <form onSubmit={handleEmailAuth}>
                                    {isSignUp && (
                                        <div className="form-group mb-3">
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                placeholder="Name" 
                                                value={name} 
                                                onChange={(e) => setName(e.target.value)} 
                                                required 
                                            />
                                        </div>
                                    )}
                                    <div className="form-group mb-3">
                                        <input 
                                            type="email" 
                                            className="form-control" 
                                            placeholder={t('auth.email')} 
                                            value={email} 
                                            onChange={(e) => setEmail(e.target.value)} 
                                            required 
                                        />
                                    </div>
                                    <div className="form-group mb-3">
                                        <input 
                                            type="password" 
                                            className="form-control" 
                                            placeholder={t('auth.password')} 
                                            value={password} 
                                            onChange={(e) => setPassword(e.target.value)} 
                                            required 
                                        />
                                    </div>

                                    {error && <div className="alert alert-danger">{error}</div>}
                                    {message && <div className="alert alert-success">{message}</div>}

                                    <div className="form-group mb-3">
                                        <button type="submit" className="site-button">
                                            {isSignUp ? t('auth.signup') : t('auth.login')}
                                        </button>
                                    </div>
                                </form>

                                <div className="text-center mt-3">
                                    <button 
                                        className="btn btn-link" 
                                        onClick={() => setIsSignUp(!isSignUp)} 
                                        style={{ textDecoration: 'none' }}
                                    >
                                        {isSignUp ? t('auth.alreadyhaveaccount') : t('auth.donthaveaccount')}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}

export default SignInPopup;